export default __webpack_public_path__ + "static/media/instagram.a0a0ce14.svg";